import UserWhiteSVG from "../shared/Navbar/LoginBlock/LoginButton/user-white.svg";

type LoggedUserIconProps = { customerName?: string };

export const LoggedUserIcon = ({ customerName }: LoggedUserIconProps) => (
  <>
    <p className="flex justify-center items-center w-4 h-3 font-bold text-white uppercase lg:hidden">
      {customerName?.charAt(0)}
    </p>
    <div className="hidden pr-2 lg:block">
      <UserWhiteSVG />
    </div>
  </>
);
